module.exports = __webpack_public_path__ + "img/statistic.0f01c88b.png";